export default __webpack_public_path__ + "static/avatar-kayi-common-7-cover-0b180de35c66823d3a1b109eb89197cc.png";